import { Field, ErrorMessage, FieldInputProps } from "formik";
import { useTranslation } from "react-i18next";
import { TitleInput } from "@/screens/register/register-engineer/style";
import InputWithIcon from "@/components/input/input";
import { ErrorText, MarginBottom } from "@/screens/login/login-seller/style";
import { FaWpforms } from "react-icons/fa";
import { LocationRegister } from "@/components/location-register/location-register";
import { CoverageLocation } from "@/models/LocationData";

interface Props {
  registerError: any;
  changeCoverageLocation: (locations: CoverageLocation[]) => void;
  setStep: React.Dispatch<React.SetStateAction<number>>;
}

export default function StepEngineerExtra({
  registerError,
  changeCoverageLocation,
  setStep,
}: Props) {
  const { t } = useTranslation();

  return (
    <>
      <TitleInput>{t("document-type")}</TitleInput>
      <Field name="engineer_document_type" as="select">
        <option value="crea">CREA</option>
        <option value="cfbio">CFBIO</option>
      </Field>
      <ErrorText>
        <ErrorMessage name="engineer_document_type" />
      </ErrorText>

      <MarginBottom />

      <TitleInput>{t("document-number")}</TitleInput>
      <Field name="engineer_document">
        {({ field }: { field: FieldInputProps<any> }) => (
          <InputWithIcon
            icon={<FaWpforms />}
            iconSize="23px"
            field={field}
            placeholder={t("type-document-engineer")}
          />
        )}
      </Field>
      <ErrorText>
        <ErrorMessage name="engineer_document" />
      </ErrorText>

      <MarginBottom />

      <TitleInput>{t("coverage-area")}</TitleInput>
      <LocationRegister
        onLocationSelected={(locations) => {
          changeCoverageLocation(
            locations.map((l) => ({
              uf: l.state_uf,
              city: l.name,
              state_uf: l.state_name || "",
            }))
          );
        }}
      />
    </>
  );
}
